import { BRAND_BY_DOMAIN } from "../constant";

export function getBrand() {
  const origin = window.location.origin;
  const domain = origin.split('/')[2];
  const brand = BRAND_BY_DOMAIN[domain];
  return brand || BRAND_BY_DOMAIN.default;
}